export { default } from '@shikijs/langs/powershell'
